import login from './login';
import header from './header';
import userDropDown from './userDropDown';

// 汇总所有的翻译文件,再暴露出去
export default {
  ...login,
  ...header,
  ...userDropDown,
};
